import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseUrls, Either, UriSegments } from "@atlassiansox/flight-deck-core";
export class ConfigRegistryHttpClientImpl {
  constructor(namespace, userAgent) {
    _defineProperty(this, "headers", {});
    this.namespace = namespace;
    this.headers = {
      "X-SSRF-Protection": "definitely-protected",
      "User-Agent": userAgent
    };
  }
  async getBlob(tag) {
    const response = await fetch(`${BaseUrls.FrontendProxyStaging}/${UriSegments.ConfigRegistryProxy}/api/v1/namespaces/${encodeURIComponent(this.namespace)}/tags/${tag}`, {
      method: "GET",
      headers: this.headers
    });
    if (!response.ok) {
      const failure = response.status === 429 ? {
        key: "rate-limit-error"
      } : response.status === 404 ? {
        key: "live-unavailable"
      } : {
        key: "config-registry-error",
        error: response.status
      };
      return Either.left(failure);
    }
    return Either.right(await response.json());
  }
}